export enum Task {
  AM_BO_CWBE = 'AM-BO-CWBE',
  AM_BO_R = 'AM-BO-R',
  AM_BO_COG = 'AM-BO-COG',
  AM_BO_A = 'AM-BO-A',
  AM_BO_BVA = 'AM-BO-BVA',
  AM_BO_BD = 'AM-BO-BD',
  AM_BO_DUA = 'AM-BO-DUA',
}
